import { useCurrentStateAndParams } from "@uirouter/react";

import { SI_SEARCH_ROUTES } from "app/common/constants/ad-intelligence-routes";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";

export interface IMonitorKeywordsEndpoints {
    table: string;
    excel: string;
    recommendations: string;
    domainsDrilldown: string;
    shareOfVoiceGraph: string;
    volumeOverTimeGraph: string;
    shareOfVoiceExcel: string;
    volumeOverTimeExcel: string;
}

const keywordResearchMonitorKeywordsEndpoints: IMonitorKeywordsEndpoints = {
    table: "/api/KeywordAnalysis/keywordsListReport/Table",
    excel: "/api/KeywordAnalysis/keywordsListReport/Excel",
    recommendations: "/api/KeywordGenerator/google/suggest",
    domainsDrilldown: "/api/KeywordAnalysis/keywordsListReport/domainsDrilldown",
    shareOfVoiceGraph: "/widgetApi/KeywordAnalysisV2/KeywordAnalysisOrganic/SiteTraffic",
    volumeOverTimeGraph: "/widgetApi/KeywordAnalysisOP/KeywordAnalysisVolumes/SingleMetric",
    shareOfVoiceExcel: "/api/KeywordAnalysis/Sites/Traffic/Excel",
    volumeOverTimeExcel: "/widgetApi/MobileTrafficV2/MobileTraffic/SearchVolumesExcel",
};

const searchAdvertisingMonitorKeywordsEndpoints: IMonitorKeywordsEndpoints = {
    table: "/api/AdIntelligence/Search/keywordsListReport/Table",
    excel: "/api/AdIntelligence/Search/keywordsListReport/Excel",
    recommendations: "/api/AdIntelligence/Search/KeywordGenerator/google/suggest",
    domainsDrilldown: "/api/AdIntelligence/Search/keywordsListReport/domainsDrilldown",
    shareOfVoiceGraph: "/widgetApi/AdIntelligence/Search/KeywordAnalysisOrganic/SiteTraffic",
    volumeOverTimeGraph: "/widgetApi/AdIntelligence/Search/KeywordAnalysisVolumes/SingleMetric",
    shareOfVoiceExcel: "/widgetApi/AdIntelligence/Search/KeywordAnalysisOrganic/SiteTraffic/Excel",
    volumeOverTimeExcel: "/widgetApi/AdIntelligence/Search/MobileTraffic/SearchVolumesExcel",
};

const monitorKeywordsEndpointsMap: Record<string, IMonitorKeywordsEndpoints> = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    digitalsuite_monitorkeywords: keywordResearchMonitorKeywordsEndpoints,
    [ROUTES.monitorKeywords]: searchAdvertisingMonitorKeywordsEndpoints,
    // Sales Intelligence mirror of Search Advertising.
    [SI_SEARCH_ROUTES.monitorKeywords]: searchAdvertisingMonitorKeywordsEndpoints,
};

export const useMonitorKeywordsEndpoints = (): IMonitorKeywordsEndpoints => {
    const { state } = useCurrentStateAndParams();
    const endpoints = monitorKeywordsEndpointsMap[state.name];

    if (!endpoints) {
        throw new Error(
            `No monitor keywords endpoints configured for state: ${state.name}. ` +
                `Available states: ${Object.keys(monitorKeywordsEndpointsMap).join(", ")}`,
        );
    }

    return endpoints;
};
